import React from 'react';
import { ArrowRight, Clock3, Radio, ShieldCheck, Users } from 'lucide-react';
import CopyButton from '../components/CopyButton.jsx';
import logo from '../assets/westcounty-mark.png';
import { content } from '../config/site.js';

export default function Hero({ lang }) {
  const t = content[lang];

  return (
    <section className="hero" id="home">
      <div className="hero-backdrop" />
      <div className="hero-line" />

      <div className="hero-content">
        <div className="eyebrow"><span className="status-dot" /> {t.hero.eyebrow}</div>
        <img className="hero-logo" src={logo} alt="GTA:WestCounty" />
        <h1>{t.hero.title}</h1>
        <p>{t.hero.description}</p>
        <div className="hero-actions">
          <a className="primary-action" href="/account/login">{t.hero.primary} <ArrowRight size={18} /></a>
          <a className="secondary-action" href="#connect">{t.hero.secondary}</a>
        </div>
      </div>

      <div className="hero-side">
        <aside className="server-card" aria-label="Live server overview">
          <div className="server-card-top">
            <span><Radio size={17} /> {t.hero.status}</span>
            <b>{t.hero.online}</b>
          </div>
          <div className="server-card-body">
            <strong>{t.hero.cardTitle}</strong>
            <p>{t.hero.cardText}</p>
          </div>
          <CopyButton copiedText={t.common.copied} />
          <div className="server-card-meta">
            <span><Users size={16} /> {t.hero.onlineMeta}</span>
            <span><Clock3 size={16} /> {t.hero.runtimeMeta}</span>
          </div>
        </aside>
      </div>
    </section>
  );
}
